<div 
    class="master"
    [ngClass]="{'master--hide-header': !showHeader}">
    <app-site-header class="master__header" *ngIf="showHeader"></app-site-header>

    <div class="master__body">
        <router-outlet></router-outlet>
    </div>
</div>

<app-mobile-nav *ngIf="showHeader"></app-mobile-nav>